/* A survey on its task card — KANON "Karty zadań" `cards.css` `.k-answers` / `.k-ans`, and
 * `catalogue6.css` `.k7-moved` for the chart of the answer that moved most. */

.reading {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: 0;
}

/* The desk draws the whole occurrence, then the answer that moved most across the card's full width
 * under it (owner, 25 September 2026). It takes whatever height the card's body has left under the
 * heading — loaded and while it waits alike, so the box does not move when the history lands — and
 * never less than its content: a survey longer than the body scrolls it rather than being cut. */
.desk {
  flex: 1 0 auto;
}

/* The small cards' three rows: the question, then the previous answer, an arrow and the new one. */
.compact {
  display: grid;
  margin: var(--space-0);
  flex: 1 1 0;
  min-width: 0;
}

.compactRow {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: var(--space-3);
  align-items: center;
  min-height: 30px;
  border-bottom: var(--border-hairline) solid var(--border);
}

.compactRow:last-child {
  border-bottom: none;
}

.compactValue {
  display: inline-flex;
  margin: var(--space-0);
  gap: var(--space-6px);
  align-items: center;
  font-size: var(--fs-note);
  font-weight: var(--fw-bold);
  font-variant-numeric: tabular-nums;
  color: var(--text);
}

.compactBefore {
  font-weight: var(--fw-medium);
  color: var(--text-2);
}


.answers {
  display: grid;
  margin: var(--space-0);
}

/* More rows than one column holds: a reading, the measurement or a medium is a third of the width,
 * three to a row, and an answer in words a half, two to a row — ten questions stand above the chart
 * at 1512×862 that way, where two columns of readings pushed the plot under its floor. */
.answersDense {
  grid-template-columns: repeat(6, minmax(0, 1fr));
  column-gap: var(--space-6);
}

.answer {
  display: grid;
  grid-template-columns: 140px minmax(0, 1fr);
  gap: var(--space-2);
  align-items: center;
  min-height: 34px;
  border-bottom: var(--border-hairline) solid var(--border);
}

.answer:last-child {
  border-bottom: none;
}

/* An answer in words is quoted, and at most two lines of it: the whole of it is behind „Przejrzyj". */
.answerWords {
  align-items: baseline;
  padding-block: var(--space-6px);
}

/* A third of the width has no room for the 140px label column: the question takes what the value
 * leaves. Every cell keeps its rule, since the last row's cells are not the list's last child. */
.answersDense .answer {
  grid-column: span 2;
  grid-template-columns: minmax(0, 1fr) auto;
  border-bottom: var(--border-hairline) solid var(--border);
}

.answersDense .answerWords {
  grid-column: span 3;
  grid-template-columns: 140px minmax(0, 1fr);
}

.valueWords {
  font-size: var(--fs-note);
  font-weight: var(--fw-semibold);
  color: var(--text);
}

.quote {
  display: -webkit-box;
  overflow: hidden;
  font-size: var(--fs-note);
  line-height: var(--lh-note);
  color: var(--text);
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.question {
  overflow: hidden;
  font-size: var(--fs-label);
  font-weight: var(--fw-semibold);
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--text-2);
}

.value {
  min-width: 0;
}



/* The desk's answers, direction B2C (owner, 5 November 2026): the question a step larger and
 * regular, the answer semibold with the figures' tight tracking — the weight moves from the
 * question to what the client said. */
.desk .question {
  font-size: var(--type-control);
  font-weight: var(--fw-regular);
}

.desk .value {
  font-weight: var(--fw-semibold);
  letter-spacing: var(--ls-display);
}

.moved {
  display: flex;
  flex-direction: column;
  gap: var(--space-6px);
  padding: var(--space-14px) var(--space-4) var(--space-2);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-md);
}

/* At the foot of the body, full width, and as tall as the room under the answers allows between the
 * plot's floor and its ceiling — a real plot, never one stretched to fill a tall window. Unframed:
 * the answers' last rule is the line above it, and the frame's 24px are plot. */
.desk .moved {
  flex: 1 0 auto;
  justify-content: flex-end;
  padding: var(--space-0);
  margin-block-start: auto;
  border-style: none;
}

.deskPlot {
  flex: 1 0 var(--h-task-survey-plot);
  min-height: var(--h-task-survey-plot);
  max-height: var(--h-task-survey-plot-max);
}

.quick .moved,
.short .moved {
  padding: var(--space-0);
  border-style: none;
}

/* The Przegląd's card: the three rows beside the chart of the one that moved most. */
.quick {
  flex-direction: row;
  gap: var(--space-5);
  align-items: center;
}

.quick .moved {
  flex: 1 1 0;
  min-width: 0;
}

.movedHead {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1) var(--space-3);
  align-items: baseline;
  font-size: var(--fs-note);
  color: var(--text-2);
}

.movedHead b {
  font-size: var(--fs-body);
  font-weight: var(--fw-extrabold);
  color: var(--text);
}

.change {
  font-style: normal;
  font-weight: var(--fw-bold);
  color: var(--text);
}

.reserve {
  display: block;
  width: 100%;
  height: var(--h-task-survey-reserve);
  border-radius: var(--radius-12px);
}

/* The desk's reserve is the room the loaded reading takes: all that is left under the heading. */
.desk .reserve {
  flex: 1 0 var(--h-task-survey-reserve);
  height: auto;
}

.quick .reserve {
  height: var(--h-task-survey-plot-quick);
}

/* The Pulpit's three rows of 30. */
.short .reserve {
  height: calc(3 * 30px);
}

/* The history read failed: said in words, in the reserve's place. */
.failed {
  margin: var(--space-0);
  font-size: var(--fs-note);
  line-height: var(--lh-normal);
  color: var(--text-2);
}
